module.exports = __webpack_public_path__ + "static/media/DE_map@2x.bbae14be.png";